import { Box } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { DateFormats } from '@uplift/constants';
import { DateObject } from '@uplift/services';
import { Button } from '../../Button';
import { useStyles } from '../styles';

export type EmptySlotsProps = {
  getNextAvailabilityDate: () => (DateObject | null);
  onGoToNextAvailability: (nextAvailability: DateObject) => void;
};

export const EmptySlots: React.VFC<EmptySlotsProps> = props => {
  const { classes } = useStyles();
  const nextAvailabilityDate = props.getNextAvailabilityDate();

  const text = nextAvailabilityDate
    ? `Next Availability is ${nextAvailabilityDate.format(DateFormats.partialWeekdayPartialMonthDate)}`
    : 'No upcoming availability for this provider';

  return (
    <Box className={classes.emptySlots}>
      <Button
        variant="contained"
        color="secondary"
        onClick={nextAvailabilityDate && (() => props.onGoToNextAvailability(nextAvailabilityDate))}
        disabled={!nextAvailabilityDate}
        className={classes.emptySlotsButton}
        size="small"
      >
        {text}{!!nextAvailabilityDate && <ArrowForward fontSize="small" />}
      </Button>
    </Box>
  );
};
